// extracted by mini-css-extract-plugin
module.exports = {"bold":"faq_bold__3zkCA"};